module.exports = "<!DOCTYPE html>\n<div class=\"front-header\"></div>\n<div class=\"container\" style=\"text-align:center;\">\n    <img src=\"../../../assets/images/B Light.svg\" alt=\"Logo White\" class=\"logo\" id=\"logo\" [@loadState]=\"loaded1\">\n    <h1 class=\"title\" [@loadState]=\"loaded2\">B R U H N O</h1>\n    <h4 style=\"margin-top: -20px; color: #424242;\" class=\"mat-typography\" [@loadState]=\"loaded3\">My name is Nicolai Bruhn Lauritsen and this is my personal portfolio and playground</h4>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/front/header/header.component.html
// module id = ../../../../../src/app/front/header/header.component.html
// module chunks = main